import { render } from "./compress.vue?vue&type=template&id=081e4b83&scoped=true"
import script from "./compress.vue?vue&type=script&lang=js"
export * from "./compress.vue?vue&type=script&lang=js"

import "./compress.vue?vue&type=style&index=0&id=081e4b83&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081e4b83"]])

export default __exports__